import { Component, OnInit } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

import { TokenService } from '@shared/services/token.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'vitens-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

	navWrapIsActive: boolean = false;
	isAuthenticated: boolean = false;
	isAdmin: boolean = false;
	name: string = '';
	accountSubscription: Subscription;


	constructor(
		private msalService: MsalService,
		private router: Router,
		private tokenService: TokenService)
	{
		this.router.events
		.pipe(filter((event: Event): event is NavigationStart => 
			event instanceof NavigationStart))
		.subscribe(() => this.navWrapIsActive = false);
	}
	
	ngOnInit() {
		this.updateAuthStatus();
	}

	async updateAuthStatus() {
		this.msalService.initialize().subscribe(async () => {
			const account: AccountInfo = this.msalService.instance.getActiveAccount();
			this.isAuthenticated = !!account;
	
			if (this.isAuthenticated) {
				this.name = account?.username || account?.name || '';
				this.checkAdminRole();
			} else {
				this.name = '';
				this.isAdmin = false;
			}
		});
	}

	async checkAdminRole() {
		this.isAdmin = await this.tokenService.hasAdminRole();
	}

	toggleNavWrap() {

		this.navWrapIsActive = !this.navWrapIsActive;
	}
}
